export default __webpack_public_path__ + "static/media/toggle1.ce0db784.svg";